import React, { useState, useEffect } from 'react';

const Gallery = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showModal, setShowModal] = useState(false);
  const [galleryData, setGalleryData] = useState([
    {
      id: 1,
      media: '/assets/images/Latest-Home-Interior-Design-Kolkata.jpg',
      name: 'Modern Living Room',
      text: 'Contemporary living room interior design in Kolkata.'
    },
    {
      id: 2,
      media: '/assets/images/Low-Cost-Home-Interior-Furniture-Design-Ideas-Kolkata.jpg',
      name: 'Budget Bedroom',
      text: 'Low cost furniture ideas for 1BHK bedrooms.'
    },
    {
      id: 3,
      media: '/assets/images/Residential-Interior-Decoration-Kolkata.jpg',
      name: 'Full Home Decor',
      text: 'Complete residential interior decoration services.'
    }
  ]);
  const [formData, setFormData] = useState({ id: null, media: '', name: '', text: '' });

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleOpenModal = (item = null) => {
    if (item) {
      setFormData(item);
    } else {
      setFormData({ id: null, media: '', name: '', text: '' });
    }
    setShowModal(true);
  };

  const handleSave = () => {
    if (formData.id) {
      setGalleryData(galleryData.map(d => (d.id === formData.id ? formData : d)));
    } else {
      setGalleryData([...galleryData, { ...formData, id: galleryData.length ? Math.max(...galleryData.map(d => d.id)) + 1 : 1 }]);
    }
    setShowModal(false);
  };

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this gallery item?')) {
      setGalleryData(galleryData.filter(d => d.id !== id));
    }
  };

  const stylesD = {
    width: "169%",
    paddingRight: "1102px",
    paddingLeft: "15px",
    marginRight: "auto",
    marginLeft: "auto"
  };

  return (
    <>
    <div className="container-fluid " style={isMobile ? {} : stylesD}>
      <div className="d-flex justify-content-between align-items-center mb-3 px-2 w-100">
        <h3 className="m-0">Gallery</h3>
        <button className="btn btn-primary" onClick={() => handleOpenModal()}>+ Add New</button>
      </div>

      <div className="table-responsive w-100 p-0">
        <table className="table table-bordered table-striped bg-white w-100 m-0">
          <thead className="thead-dark">
            <tr className="col-md-12">
              <th>ID</th>
              <th>Image</th>
              <th>Title</th>
              <th>Description</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {galleryData.map((item) => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>
                  <img src={item.media || '/assets/images/placeholder.jpg'} alt={item.name} width="80" />
                </td>
                <td>{item.name}</td>
                <td>{item.text}</td>
                <td className="text-center">
                  <button className="btn btn-sm btn-outline-primary mr-2" onClick={() => handleOpenModal(item)}>Edit</button>
                  <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(item.id)}>Delete</button>
                </td>
              </tr>
            ))}
            {galleryData.length === 0 && (
              <tr>
                <td colSpan="5" className="text-center">No records found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>

    {showModal && (
      <div className="modal show d-block" style={{ background: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{formData.id ? "Edit Gallery Item" : "Add Gallery Item"}</h5>
              <button className="close" style={{background: 'transparent', border: 'none', fontSize: '1.5rem'}} onClick={() => setShowModal(false)}>
                ×
              </button>
            </div>
            <div className="modal-body">
              <input type="text"
                className="form-control mb-2"
                placeholder="Image URL"
                value={formData.media}
                onChange={(e) => setFormData({ ...formData, media: e.target.value })}
              />
              <input type="text"
                className="form-control mb-2"
                placeholder="Title"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              />
              <textarea
                className="form-control mb-2"
                rows="3"
                placeholder="Description"
                value={formData.text}
                onChange={(e) => setFormData({ ...formData, text: e.target.value })}
              />
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                Close
              </button>
              <button className="btn btn-primary" onClick={handleSave}>
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    )}
    </>
  );
};

export default Gallery;
